import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { AssignDialog } from "@/pages/admin/AssignDialog";
import { JobDetailSheet } from "@/pages/admin/JobDetailSheet";
import { EditJobDialog } from "@/pages/admin/EditJobDialog";

export function useJobActions(reload) {
  const [detail, setDetail] = useState(null);
  const [assign, setAssign] = useState(null);
  const [edit, setEdit] = useState(null);

  const reject = async (job) => {
    if (!window.confirm("Rifiutare questa richiesta?")) return;
    try {
      await api.post(`/admin/jobs/${job.id}/reject`);
      toast.success("Richiesta rifiutata");
      setDetail(null);
      reload();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  const resend = async (job, index) => {
    try {
      const { data } = await api.post(`/admin/jobs/${job.id}/wa-resend/${index}`);
      const last = data.wa_messages[data.wa_messages.length - 1];
      last.status === "failed" ? toast.error(`Reinvio non riuscito: ${last.error || ""}`) : toast.success("WhatsApp reinviato");
      setDetail(data);
      reload();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  const ui = (
    <>
      <JobDetailSheet job={detail} onClose={() => setDetail(null)} onAssign={(j) => setAssign(j)} onReject={reject} onEdit={setEdit} onResend={resend} onChanged={() => { setDetail(null); reload(); }} />
      <EditJobDialog job={edit} open={!!edit} onOpenChange={(o) => !o && setEdit(null)}
        onSaved={(j) => { setDetail((d) => (d ? j : d)); reload(); }} />
      <AssignDialog job={assign} open={!!assign} onOpenChange={(o) => !o && setAssign(null)}
        onDone={(j) => { setDetail((d) => (d ? j : d)); reload(); }} />
    </>
  );
  return { openDetail: setDetail, openAssign: setAssign, reject, ui };
}
